(function ($) {
  'use strict';

  /**
   * Site Popups
   * ---
   * - Uses MagnificPopup.js
   */


  /**
   * Inline Popups
   * - Uses the `data-mfp-src` attribute to assign popup container
   */

  var $inline_popup_button = $('.js-popup-button');

  if ( $inline_popup_button.length ) {
    $inline_popup_button.magnificPopup({
      type: 'inline',
      midClick: true,
    });
  }

  $('.js-popup-close').on('click', function () {
    $.magnificPopup.close();
  });


  /**
   * Video Popups
   */

  var $video_popup_button = $('.js-video-popup');

  $video_popup_button.each(function () {
    var $this = $(this);
    var this_video_url = $this.attr( 'data-video-url' );

    $this.magnificPopup({
      items: [{ src: this_video_url }],
      type: 'iframe',
      iframe: {
        patterns: {
          playervimeo: {
            index: 'player.vimeo.com',
            id: function ( url ) {
              return url;
            },
            src: '%id%',
          },
        },
      },
    });
  });

})(jQuery);
